import React from 'react';
import AudioList from './AudioList';
import WatchList from './WatchList';
import { VersionListWrapper, VersionWrapper, VersionLabel } from '../medialinks.style';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import ErrorBoundaryWrapper from '../../ErrorFallback/ErrorBoundaryWrapper';

const UNDEFINED = 'undefined';
const fvVersion = typeof FV_VERSION !== UNDEFINED ? FV_VERSION : '';
const appVersion = (typeof APP_VERSION !== UNDEFINED ? APP_VERSION : 'dev') + (fvVersion ? ',' : '');

const MediaLinksMenu = () => {
    const translate = useTranslate();

    const versionText = translate('label_version', 'version') + ':';

    return (
        <ErrorBoundaryWrapper componentName='Media Menu'>
            <WatchList />
            <AudioList />
            <VersionListWrapper>
                <VersionLabel>
                    {versionText}
                </VersionLabel>
                <div>
                    <VersionWrapper>
                        {appVersion} {fvVersion}
                    </VersionWrapper>
                </div>
            </VersionListWrapper>
        </ErrorBoundaryWrapper>
    );
};

export default MediaLinksMenu;
